import axios from "axios";
import { requiredParam } from "@utils/func";

const getBureauCompanies = ({
  companyId = requiredParam("companyId"),
} = {}) => {
  return axios.get(`bureau-companies/${companyId}/companies`);
};

export { getBureauCompanies };
